<template>
  <v-layout row>
      <v-flex md2 class="pa-0">
          <sub-side-bar :items="settingsMenu"></sub-side-bar>
      </v-flex>
      <v-flex md10>
          <router-view/>
      </v-flex>
  </v-layout>

</template>

<script>
  import subSideBar from "../components/common/subSideBar";
  export default {
      name: "llm",
      components: {
          subSideBar
      },
      data () {
          return {
              settingsMenu: {
                  title: 'LLM',
                  menu: [
                      {
                          // title: 'General Settings',
                          items: [
                              {
                                  title: 'LLM Configuration',
                                  link: '/llm/configuration'
                              },
                              {
                                  title: 'Knowledge Base',
                                  link: '/llm/knowledge-base'
                              },
                              {
                                  title: 'Questions & Answers',
                                  link: '/llm/questions-answers'
                              },
                          ],
                      },
                  ]
              }
          }
      },
  }
</script>

<style scoped>
  .btn-input {
      height: 45px;
  }
  .add-lang {
      max-width: 500px;
      margin: auto;
  }
</style>
